import { __decorate, __metadata } from "tslib";
import { TemperatureUnit } from '../../utils/unit';
import { SerializableObject } from '../decorators';
import { SensorValue } from './SensorValue';
/**
 * @category Sensor Value
 */
let Temperature = class Temperature extends SensorValue {
  constructor(value = 0, unit = TemperatureUnit.CELCIUS) {
    super(value, undefined, undefined, unit, TemperatureUnit.CELCIUS);
  }
  get value() {
    return this.x;
  }
  set value(x) {
    this.x = x;
  }
};
Temperature = __decorate([SerializableObject(), __metadata("design:paramtypes", [Object, Object])], Temperature);
export { Temperature };